export const READ_MORE = 'Read More';
export const READ_LESS = 'Read Less';
export const PLAY_NOW = 'Play Now';
export const CONTINUE_READING = 'Continue Reading';

// NEWS Page
export const TOP_NEWS = 'Top News';
export const TOP_TEN_NEWS = 'Top 10 News';
export const VIEW_ALL = 'View All';
export const BREAKING_NEWS = 'Breaking News';
export const ENTERTAINMENT_NEWS = 'Entertainment News';
export const NEWS_IN_BRIEF = 'News in Brief';
export const OTHER_NEWS = 'Other News';
export const LATEST_NEWS = 'News of Interest';

// HOME PAGE
export const HEADLINES = 'Headlines';
export const MORE_GAMES = 'More Games';
export const MORE_DEAL = 'More Deals';
export const CHOOSE = 'Choose';
export const YOUR_ZODIAC = 'your Zodiac';
export const HOROSCOPE_TEXT = 'Today’s Horoscope';
export const PROCEED = 'Continue';
export const CHOOSE_YOUR_ZODIAC = 'Choose your Zodiac';
export const CHANGE_SIGN = 'Change Sign';
export const CHECK_TODAYS = "Check today's";
export const PREDICTION_FOR = 'prediction for';
export const ROPOSO_ENTERTAINMENT = 'Watch Now';
export const DEALS_OF_THE_DAY = 'Deals of the Day';
export const TOP_TRENDS_TODAY = 'Top Trends Today';
export const AROUND_THE_WORLD = 'Around the World';

// DEALS FEED
export const POPULAR_BRANDS = 'Popular Brands';
export const VIEW_OFFERS = 'VIEW OFFERS';
export const TRENDING_COLLECTIONS = 'Trending Collections';
export const EVERYDAY_ESSENTIAL = 'Top Categories';
export const EXPORE_MORE_OFFERS = 'Explore More Offers';

// ZAPPS
export const NEWS = 'NEWS';
export const DEALS = 'DEALS';
export const GAMES = 'GAMES';
export const HOROSCOPE = 'HOROSCOPE';

export const TOP_NEWS_TYPE = 'topNews';
export const ALL_NEWS_TYPE = 'allNews';

// ERROR
export const GENERIC_ERROR = 'Something went wrong!';

// Games Feed
export const PLAY = 'Play';
export const EXPLORE_MORE_GAMES = 'Explore More Games';
export const RECENTLY_PLAYED = 'Recently Played Games';
export const GAME_OF_THE_DAY = 'Game of the Day';

// Weather
export const PRECIPITATION = 'Precipitation';
export const HUMIDITY = 'Humidity';

//COOKIE CONSENT
export const CLOSE = 'Got it';

// USER FEEDBACK
export const EMAIL_TO = 'support_swishme@inmobi.com';
export const EMAIL_SUBJECT = 'MySites feedback';

export const TOP_NEWS_OF_THE_DAY = 'Top News of <br /> the Day';
export const GAME_OF_THE_DAY_TEXT = 'Game <br /> of the day';
export const GAME_LOADING = 'Loading...';

export const SHARE = 'SHARE';
export const VIDEO_PLAYING_ERROR_MESSAGE = 'Video playback error. Please try again later.';
export const VIDEO_NOT_FOUND_MESSAGE = 'Video not found';

// TOAST MESSAGES
export const TOAST_MESSAGE = 'Bookmarked Successfully!';
export const VIEW_NOW = 'View Now';

export const accordionContent = [
  {
    head: 'Why does MySites re-direct me to Chrome?',
    content:
      "Currently, when you use the app, it opens Chrome to access the website. We understand this might not be ideal. However, we're working on improving our service and you will soon be able to access the website directly within the app, without the need to open a browser."
  },
  {
    head: "I'm new to MySites, where should I start?",
    content:
      'Head over to the homepage. Scroll down and you’ll quickly find a variety of content and information. Feel free to go through our About Us section and this FAQ document. If you have more questions, you can always reach out to us at <a style="color: #2f81f7;" href="mailto:support_swishme@inmobi.com">Swish Mail</a> or try the user feedback option.'
  },
  {
    head: 'Are the games being downloaded on my phone? Do I have to download these games in order to play them? ',
    content:
      'These games are instant games which means there are no downloads, just pure instant fun. None of the instant games need to be downloaded. They are free for you to play at all times. '
  },
  {
    head: 'Is MySites a news publisher?',
    content:
      'We do not publish any news of our own. We aggregate news from a variety of sources and present them to you to help you stay updated with the latest events around the world and you.'
  },
  {
    head: 'Does MySites have access to my phone?',
    content:
      'We do not have the ability to control or access any aspect of your phone or its settings.'
  },
  {
    head: 'Can I access my account details within MySites?',
    content:
      "Absolutely!  While you can't view your account details directly with us just yet, you can easily access them through your carrier's website, like StraightTalk.com. Our team is currently developing a convenient tab within the app to streamline this process for you in the future."
  },
  {
    head: 'Why can’t I see deals anymore?',
    content:
      "We've temporarily paused the Deals section to make it even better for you. We're working on a new shopping experience, so get ready to snag some awesome deals very soon!"
  },
  {
    head: 'Can I set up my Wi-Fi hotspot from MySites?',
    content: `<div>Don't worry about MySites connecting to your Wi-Fi hotspot – it won't! If you need help setting up your phone's hotspot, here are some resources: <ul><li>Android – Simple steps to turn on your hotspot can be found here: <a style='color: #2f81f7;' href='https://support.google.com/android/answer/9059108?hl=en'>Google Support</a>.</li> <li>iPhone – Apple's guide to setting up a hotspot is available here: <a style='color: #2f81f7;' href='https://support.apple.com/en-asia/111785'>Apple Support</a>.</li></ul></div>`
  },
  {
    head: 'How do I uninstall MySites?',
    content:
      "We are sorry to see you go.  MySites can be disabled with the below steps: <ol><li>Find the MySites app. Just tap and hold the MySites icon on your device's home screen.</li> <li>Tap 'App Info' (or similar wording depending on your device). Alternatively, you can head over to settings and find ‘MySites’ under ‘Apps’.</li> <li>Choose 'Disable'. You'll see a few options, including 'Open', 'Disable', and 'Force Stop'. Select 'Disable' to turn off MySites.</li></ol> Want to bring it back later?  You can always re-enable MySites from the same 'App Info' menu."
  },
  {
    head: 'Can I edit the quick links (Youtube, Facebook, etc.) shown on my homepage?',
    content:
      "We understand you might want to customize your homepage with quick links that are relevant to you. While this feature isn't available just yet, we're working hard to bring you full control over your quick links, including Youtube, Facebook, and others. Watch this space!"
  },
  {
    head: 'Is MySites free to use?',
    content:
      'You bet! MySites is completely free to use. No hidden fees, no credit card needed. Just jump in and explore!'
  },
  {
    head: 'How do I report objectionable content?',
    content:
      'If you come across objectional content, you can write to us via the user feedback option or to <a style="color: #2f81f7;" href="mailto:support_swishme@inmobi.com">Swish Mail</a>. Any details about the image, the title or a screenshot would help bolster your case.'
  },
  {
    head: 'How can I contact support?',
    content:
      'If you have questions related to MySites you can write to us at <a style="color: #2f81f7;" href="mailto:support_swishme@inmobi.com">Swish Mail</a> or try user feedback. If you have questions related to your carrier services, please head over to your account which is accessible from the links on the top of the homepage.'
  },
  {
    head: 'What videos can I watch on MySites?',
    content:
      'You can watch news videos which spread across politics, sports, entertainment and much more.'
  },
  {
    head: 'What type of games are available on MySites?',
    content:
      'On MySites, you will find instant casual games that are not downloaded on your phone. They run the gamut across categories like action, casual, puzzle and sports.'
  },
  {
    head: 'Why does MySites feel slow or unresponsive at times?',
    content:
      'We are always working to provide you the best experience and support. If you face any issues, please feel free to reach out to us via user feedback or <a style="color: #2f81f7;" href="mailto:support_swishme@inmobi.com">Swish Mail</a>'
  },
  {
    head: 'Have any more queries?',
    content:
      'Drop us a note on <a style="color: #2f81f7;" href="mailto:support_swishme@inmobi.com">Swish Mail</a> and we’ll get back to you.'
  }
];

export const ANALYTICS_INIT_ERROR = 'Analytics not initialized';
